import React, { useEffect } from 'react';
import { lighten } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {Tooltip as TooltipRecharts} from 'recharts';

import {
  IconButton,
  Grid, 
  Paper,
  Typography,
  Tooltip
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import {
  Radar, RadarChart, PolarGrid, Legend,
  PolarAngleAxis, PolarRadiusAxis,
} from 'recharts';

import socket from '../../../../services/socket';
import useStylesMain from '../../../../useStyles';
import Title from '../../../../components/Title';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor: lighten(theme.palette.primary.light, 0.5)
      }
    },
    tableCell: {
      "$selected &": {
        color: lighten(theme.palette.primary.light, 0.5)
      }
    },
    selected: {},
    avatar_image:{
        width:  "100px",
        height: "100px",
        borderRadius: "50%",
      },
    avatar_text:{
      color: "#14143c",
      backgroundColor: "white",
      padding: "3px",
      fontFamily: "Coboto",
      fontSize:15
    }
  }));

const radarDataSubject = [
  {
    subject: 'Vendas'
  },
  {
    subject: 'Ticket'
  },
  {
    subject: 'Conversão'
  },
  {
    subject: 'PA'
  },
  {
    subject: 'Atend.'
  }
]
let clr_plt = ["#2584A5","#F6C85E","#6F4E7B","#9DD766","#CA472E","#FA9F56","#8DDDD0"]
export default function RadarChartStores(props) {
    const classes = useStyles();
    const classesMain = useStylesMain()
    const [storesData,setStoresData] = React.useState([]) //to plot
    const [stores,setStores] = React.useState([]) //all stors
    const [selectedStores,setSelectedStores] = React.useState([])
    
    useEffect( () => {   
      function askRadarChart(propsStores){
        let ids = []
        propsStores.storesDisplayed.forEach((stores)=>{
          ids.push(stores.store_id)
        })
        socket.emit('/vezo/histData/askRadarData',{ 
                                            'store_id_list': ids,
                                            'date': propsStores.date,
                                            }
                                        ,(data)=>{console.log(data);});
      }

      async function loadRadarChart(propsStores){
          askRadarChart(propsStores);
          socket.on('/vezo/histData/askRadarData',(propsStores)=>{
            // When the server sends a updatePaperInfo, it asks for newer intel
            askRadarChart(propsStores);
          })  
          socket.on('/vezo/histData/RadarData',(data)=>{
            let radarData = radarDataSubject
            data.forEach((store)=>{
              radarData[0][String(store.name)] = (store.revenue)?(100*store.revenue).toFixed(2):0
              radarData[1][String(store.name)] = (store.nbsales)?(100*store.revenue/store.nbsales).toFixed(2):0
              radarData[2][String(store.name)] = (store.attendance)?(100*store.nbsales/store.attendance).toFixed(2):0
              radarData[3][String(store.name)] = (store.nbsales)?(100*store.nbitems/store.nbsales).toFixed(2):0
              radarData[4][String(store.name)] = (store.attendance)?(100*store.attendance).toFixed(2):0
            })
            radarData[0]["store"] = 100
            radarData[1]["store"] = 100
            radarData[2]["store"] = 100
            radarData[3]["store"] = 100
            radarData[4]["store"] = 100
            setStoresData(radarData)
            setStores(data)
          })
          return () => socket.disconnect();
      }

      loadRadarChart(props);       
      
    },[props]);  
    
    
    useEffect(()=>{
      let ids = []
      props.storesDisplayed.forEach((stores)=>{
        ids.push(stores.store_id)
      })
      const result = stores.filter(store => ids.includes(store.id) )
      setSelectedStores(result)
    },[storesData,stores,props])

    const CustomTooltip = ({ active, payload, label }) => {
        if (active&&payload) {
          return (
            <div className="custom-tooltip">
              <Typography  
                variant='h1' component='h1'
                classes={{ h1: classes.avatar_text }}>
                  {`${label}`}
              </Typography>
              {payload.map((inf)=>{
                if(inf.name==="Loja"){
                  return null
                }
                if(Number(inf.value-100).toFixed(2)>=0){
                  return(
                    <Typography  
                    variant='h1' component='h1'
                    classes={{ h1: classes.avatar_text }}>
                      {`${inf.name} : média da rede + ${Number(inf.value-100).toFixed(2)}%.`}
                    </Typography>
                  )
                }
                else{
                  return(
                    <Typography  
                    variant='h1' component='h1'
                    classes={{ h1: classes.avatar_text }}>
                      {`${inf.name} : média da rede ${Number(inf.value-100).toFixed(2)}%.`}
                    </Typography>
                  )
                }
              })}
            </div>
          );
        }
        return null;
      };

    return (
      <Grid item xs={12} md={12} lg={6}>
          <Paper className={classesMain.paper}>
              <Grid container spacing={3}  justifyContent={"center"} direction="row">
                  <Grid item xs={12} md={2} lg={1}>
                      <Tooltip title="Forças e fraquezas de cada loja em relação à rede!">
                          <IconButton aria-label="Selecionar" size="large">
                          <InfoIcon />
                          </IconButton>
                      </Tooltip>
                  </Grid>
                  <Grid item xs={12} md={10} lg={11}>
                      <Title>Forças e Fraquezas</Title>
                  </Grid>
              </Grid>
              <RadarChart  width={500} height={400}  data={storesData}>
                  <PolarGrid />
                  <PolarAngleAxis dataKey="subject" name="name"/>
                  <PolarRadiusAxis  hide={true}  domain={[0, 400]}/>
                  <Radar name="Rede" dataKey="store" stroke="#02023c" fill="#02023c" fillOpacity={0.6} />
                  {selectedStores.map( (store,index)=>{
                      return(
                      <Radar name={store.name} dataKey={String(store.name)} stroke={clr_plt[index]} fill={clr_plt[index]} fillOpacity={0.6} />
                      )
                  })}
                  <TooltipRecharts content={<CustomTooltip />} />
                  <Legend />
              </RadarChart>
          </Paper >
      </Grid>
    );

}